module.exports = __webpack_public_path__ + "static/media/whatsApp.4bc99cf0.png";